// extracted by mini-css-extract-plugin
export default {"root":"form-styled-input-base-fixed__root___peKDy","input":"form-styled-input-base-fixed__input___z4JQk"};